import React from 'react';
import { Link } from 'react-router-dom';
import './Banner.scss';
import IndexingOverview from '../../../indexing/IndexingOverview/IndexingOverview';

const IndexingOverviewPage: React.FC = () => {
  return (
    <>
      <div style={{ marginBottom: '64px' }}>
        <h1>Indexing Overview</h1>
        <div>
          Indexing Overview Page is to show indexing details based on different index type.
        </div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{ marginBottom: '32px' }}>

          <IndexingOverview title={'Standard'} />
        </div>

        <Link to="/demo">Return</Link>
        <hr />
        <div style={{ marginBottom: '32px' }}>

          <IndexingOverview title={'NLP'} />
        </div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{ marginBottom: '32px' }}>

          <IndexingOverview title={'Custom'} />
        </div>
      </div>
    </>
  );
};

export default IndexingOverviewPage;
